var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":_vm.imagePath,"height":_vm.size,"alt":"company logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }